import { Component, OnInit, ViewChild } from '@angular/core';
import { WcGridComponent } from '../../components/wc-grid/wc-grid.component';
import { GlobalUsersComponent } from '../global-users/global-users.component';
import { PendingUsersComponent } from '../pending-users/pending-users.component';
import { EditDialogService } from '../../utility/dialog/edit-dialog-service';
import { HttpService } from '../../utility/http-service';
import { RouterService } from '../../utility/router-service';
import { LoginService } from '../../../services/login-service';
import { MatDialogConfig } from '@angular/material/dialog';
import { RegionSelectModel } from '../client/client.component';
import { GenericDragSelectComponent } from '../../components/generic-drag-select/generic-drag-select.component';
import { RolesPanelComponent } from '../../components/roles-panel/roles-panel.component';

@Component({
  selector: 'user-management',
  standalone: false,
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.css'
})
export class UserManagementComponent implements OnInit {

  @ViewChild('usersGrid') usersGrid?: WcGridComponent;
  @ViewChild('globalUsersComp') globalUsersComp?: GlobalUsersComponent;
  @ViewChild('pendingUsersComp') pendingUsersComp?: PendingUsersComponent;

  selectedUser: any = null;


  constructor(
    private eDialog: EditDialogService,
    private http: HttpService,
    private router: RouterService,
    public loginService: LoginService
  ) {}

  ngOnInit(): void {}

  onGlobalTabClick(): void {
    this.globalUsersComp?.reload();
  }

  onPendingTabClick(): void {
    this.pendingUsersComp?.reload();
  }

  onUserSelected(row: any): void {
    this.selectedUser = row;
  }

  get selectedUserId(): string | null {
    if (!this.selectedUser) return null;
    return this.selectedUser['Id'] ?? this.selectedUser['id'] ?? null;
  }

  impersonateUser(): void {
    if (!this.selectedUser) return;
    const userId = this.selectedUser['Id'] ?? this.selectedUser['id'];
    this.http.post(`User/Impersonate?userId=${userId}`, async () => {
      await this.loginService.reload();
      this.router.router.navigateByUrl('/');
    });
  }

  selectFracXRegions(): void {
    const record = this.selectedUser;
    if (!record) return;
    const recordId = record['Id'] ?? record['id'];
    this.http.get<RegionSelectModel>(`FracX/ActiveUserRegions?userId=${recordId}`, (f: RegionSelectModel) => {
      this.eDialog.openModal(GenericDragSelectComponent, (c: MatDialogConfig) => {
        c.data = {
          title: 'Select Regions',
          current: f.current,
          available: f.available,
          onSave: (current: string[], available: string[]) => {
            const formData = new FormData();
            formData.append('selectedRegions', JSON.stringify(current));
            formData.append('userId', recordId);
            this.http.post('FracX/SaveUserRegions', () => this.usersGrid?.reload(1), null, formData);
          }
        };
        c.minWidth = 'fit-content';
        c.minHeight = 'fit-content';
      });
    });
  }
}
